export const isSwissMobilePhoneNumber = function (phoneNumber: string): boolean {
  // Remove all whitespace and common separators for more flexible input handling
  const cleanedNumber = phoneNumber.replace(/[\s\-\(\)]/g, '');
  // Swiss mobile phone regex - matches 076-079 ranges with various prefixes
  const swissMobilePhoneRegex = /^(?:(?:|0{1,2}|\+{0,2})41(?:|\(0\))|0)(7)([6-9])(\d{3})(\d{2})(\d{2})$/;
  return swissMobilePhoneRegex.test(cleanedNumber);
};
